import React from "react";
import Carousel from "react-bootstrap/Carousel";
import moment from "moment";
import { Config } from "../Config";
import CountdownTimer from "./CountdownTimer";

const ImageSlider = ({ data }) => {
  const activeProjects = data?.projects?.filter(p => p.status === 1) || [];

  return (
    <div>
      <Carousel>
        {data?.images?.map((slider, index) => (
          <Carousel.Item key={index}>
            <a href={`${Config.docUrl}${slider.button_url}`} download target="_blank" 
 rel="noreferrer">
              <img src={`${Config.imageUrl}/sliders/${slider.image}`} className="w-100 slider-image" alt="" />
            </a>
            
            {!data.hideCaption && activeProjects.length > 0 && (
              <Carousel.Caption className="d-flex justify-content-center" style={{ bottom: '20px', left: 0, right: 0 }}>
                <div className="d-flex flex-wrap justify-content-center gap-4" style={{ background: 'rgba(0,0,0,0.7)', borderRadius: '8px', padding: '10px 20px', display: 'inline-flex' }}>
                  {activeProjects.map((proj, i) => (
                    <div key={i} className={`mb-1 ${i !== activeProjects.length - 1 ? 'border-end pe-4' : ''}`}>
                      <h6 className="text-white mb-1 fw-bold" style={{ fontSize: '15px' }}>{proj.project_name}</h6>
                      <div className="mb-1 text-warning" style={{ fontSize: '12px' }}>
                        Start: {moment(proj.start_date).format('DD-MM-YYYY')} &nbsp;|&nbsp; 
                        End: {moment(proj.date).format('DD-MM-YYYY')}
                      </div>
                      <CountdownTimer startDate={proj.start_date} endDate={proj.date} />
                    </div>
                  ))}
                </div>
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}

      </Carousel>
    </div>
  );
};

export default ImageSlider;
